import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

const categoryLabelMap: Record<string, string> = {
  entertainment: '娱乐圈',
  influencer: '网红主播',
  society: '社会事件',
  tech: '科技圈',
  sports: '体育圈',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const items: BreadcrumbItem[] = [{ label: '首页', href: '/' }];

  if (pathSegments[0] === 'category' && pathSegments[1]) {
    items.push({ label: categoryLabelMap[pathSegments[1]] || pathSegments[1], href: `/category/${pathSegments[1]}` });
  } else if (pathSegments[0] === 'article') {
    items.push({ label: '文章详情' });
  } else if (pathSegments[0] === 'about') {
    items.push({ label: '关于我们' });
  }

  return (
    <nav aria-label="面包屑导航" className="container-custom pt-20 pb-2">
      <ol className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <span className="text-foreground-300">/</span>
            )}
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-500 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}